import { render, staticRenderFns } from "./MainViewError.vue?vue&type=template&id=2c7d7926"
import script from "./MainViewError.vue?vue&type=script&lang=js"
export * from "./MainViewError.vue?vue&type=script&lang=js"
import style0 from "./MainViewError.vue?vue&type=style&index=0&id=2c7d7926&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports